import {
  SiReact, SiNextdotjs, SiVuedotjs, SiFigma, SiNodedotjs, SiExpress, SiPython, SiNestjs,
  SiMongodb, SiMysql, SiAmazonaws, SiGraphql, SiSolidity, SiRust, SiEthereum,
  SiBitcoin, SiBinance, SiJavascript, SiTypescript, SiHtml5, SiCss3, SiTailwindcss,
  SiBootstrap, SiDocker, SiGit, SiGithub, SiGitlab, SiVercel, SiFirebase,
  SiGooglecloud, SiRedis, SiPostgresql
} from 'react-icons/si';
import { 
  FaEthereum, FaBitcoin, FaJava, FaRProject, FaDocker, FaCode, FaLaptopCode
} from 'react-icons/fa';
import { 
  MdCode, MdWeb, MdStorage, MdCloud, MdDeveloperMode
} from 'react-icons/md';

export const skillCategories = [
  {
    name: "Blockchain & Web3",
    skills: [
      { name: "Solana", icon: SiEthereum, color: "#9945FF" },
      { name: "Ethereum", icon: SiEthereum, color: "#627EEA" },
      { name: "Bitcoin", icon: SiBitcoin, color: "#F7931A" },
      { name: "SUI", icon: MdCode, color: "#000000" },
      { name: "NFT", icon: MdWeb, color: "#FF007A" },
      { name: "WebGL", icon: MdCode, color: "#F7931A" },
      { name: "Solidity", icon: SiSolidity, color: "#363636" },
      { name: "Web3", icon: SiEthereum, color: "#627EEA" },
    ],
  },
  {
    name: "Frontend Development",
    skills: [
      { name: "React", icon: SiReact, color: "#61DAFB" },
      { name: "Next.js", icon: SiNextdotjs, color: "#000000" },
      { name: "Vue.js", icon: SiVuedotjs, color: "#4FC08D" },
      { name: "JavaScript", icon: SiJavascript, color: "#F7DF1E" },
      { name: "TypeScript", icon: SiTypescript, color: "#3178C6" },
      { name: "HTML5", icon: SiHtml5, color: "#E34F26" },
      { name: "CSS3", icon: SiCss3, color: "#1572B6" },
      { name: "TailwindCSS", icon: SiTailwindcss, color: "#06B6D4" },
      { name: "Bootstrap", icon: SiBootstrap, color: "#7952B3" },
      { name: "Material-UI", icon: MdCode, color: "#0081CB" },
      { name: "Figma", icon: SiFigma, color: "#F24E1E" },
    ],
  },
  {
    name: "Backend & Databases",
    skills: [
      { name: "Node.js", icon: SiNodedotjs, color: "#339933" },
      { name: "Express", icon: SiExpress, color: "#000000" },
      { name: "Nest.js", icon: SiNestjs, color: "#E0234E" },
      { name: "Python", icon: SiPython, color: "#3776AB" },
      { name: "Rust", icon: SiRust, color: "#000000" },
      { name: "Java", icon: FaJava, color: "#007396" },
      { name: "C++", icon: MdCode, color: "#00599C" },
      { name: "Kotlin", icon: MdCode, color: "#7F52FF" },
      { name: "R", icon: FaRProject, color: "#276DC3" },
      { name: "Scratch", icon: MdCode, color: "#4D97FF" },
      { name: "MongoDB", icon: SiMongodb, color: "#47A248" },
      { name: "MySQL", icon: SiMysql, color: "#4479A1" },
      { name: "PostgreSQL", icon: SiPostgresql, color: "#336791" },
      { name: "Redis", icon: SiRedis, color: "#DC382D" },
      { name: "GraphQL", icon: SiGraphql, color: "#E10098" },
    ],
  },
  {
    name: "Cloud & DevOps",
    skills: [
      { name: "AWS", icon: SiAmazonaws, color: "#FF9900" },
      { name: "Google Cloud", icon: SiGooglecloud, color: "#4285F4" },
      { name: "Firebase", icon: SiFirebase, color: "#FFCA28" },
      { name: "Vercel", icon: SiVercel, color: "#000000" },
      { name: "Docker", icon: SiDocker, color: "#2496ED" },
      { name: "Git", icon: SiGit, color: "#F05032" },
      { name: "GitHub", icon: SiGithub, color: "#181717" },
      { name: "GitLab", icon: SiGitlab, color: "#FCA326" },
      { name: "Visual Studio Code", icon: MdDeveloperMode, color: "#007ACC" },
    ],
  },
];

export const knowledgeSets = [
  "Website hosting",
  "Github",
  "Gitlab", 
  "CI/CD Pipeline",
  "Photoshop",
  "Modern | mobile Design",
  "Graphics | animations",
];
